import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import Table from '@mui/material/Table'
import TableHead from '@mui/material/TableHead'
import TableBody from '@mui/material/TableBody'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import Chip from '@mui/material/Chip'
import CircularProgress from '@mui/material/CircularProgress'

const RestTunel = require('../../libs/rest_tunnel')

const ESTADOS = ['Nueva', 'Recibida', 'En revisión', 'En proceso', 'Pendiente de información', 'Solucionada', 'Cerrada']
const COLOR_ESTADO = {
  'Nueva': 'info', 'Recibida': 'info', 'En revisión': 'warning', 'En proceso': 'primary',
  'Pendiente de información': 'warning', 'Solucionada': 'success', 'Cerrada': 'default'
}

class SoporteSeguimientosPage extends Component {
  constructor(props) {
    super(props)
    this.state = { solicitudes: [], estado: '', tipo: '', fecha_inicio: '', fecha_fin: '', cargando: false }
  }

  componentDidMount() { this.cargar() }

  cargar = () => {
    const s = this.state
    this.setState({ cargando: true })
    RestTunel.makePetition({
      method: 'POST', headers: 'JSON',
      body: { estado: s.estado, tipo: s.tipo, fecha_inicio: s.fecha_inicio, fecha_fin: s.fecha_fin },
      url: process.env.REACT_APP_URL_BACKEND + '/soporte/list'
    }, (err, data) => {
      this.setState({ cargando: false, solicitudes: err ? [] : (data || []) })
    })
  }

  set = (campo) => (e) => this.setState({ [campo]: e.target.value })

  render() {
    const s = this.state
    return (
      <Box sx={{ p: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h5">Mis solicitudes</Typography>
          <Button variant="contained" component={Link} to="/dashboard/soporte/reportar">Reportar falla</Button>
        </Box>

        <Paper sx={{ p: 2, mb: 2 }}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={6} sm={3}>
              <FormControl fullWidth size="small">
                <InputLabel>Estado</InputLabel>
                <Select label="Estado" value={s.estado} onChange={this.set('estado')}>
                  <MenuItem value="">Todos</MenuItem>
                  {ESTADOS.map(e => <MenuItem key={e} value={e}>{e}</MenuItem>)}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6} sm={3}>
              <FormControl fullWidth size="small">
                <InputLabel>Tipo</InputLabel>
                <Select label="Tipo" value={s.tipo} onChange={this.set('tipo')}>
                  <MenuItem value="">Todos</MenuItem>
                  <MenuItem value="maquina">Máquina</MenuItem>
                  <MenuItem value="plataforma">Plataforma</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6} sm={2}>
              <TextField fullWidth size="small" type="date" label="Desde" InputLabelProps={{ shrink: true }} value={s.fecha_inicio} onChange={this.set('fecha_inicio')} />
            </Grid>
            <Grid item xs={6} sm={2}>
              <TextField fullWidth size="small" type="date" label="Hasta" InputLabelProps={{ shrink: true }} value={s.fecha_fin} onChange={this.set('fecha_fin')} />
            </Grid>
            <Grid item xs={12} sm={2}>
              <Button fullWidth variant="outlined" onClick={this.cargar}>Buscar</Button>
            </Grid>
          </Grid>
        </Paper>

        <Paper>
          {s.cargando ? <Box sx={{ p: 3, textAlign: 'center' }}><CircularProgress /></Box> :
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>N°</TableCell>
                <TableCell>Fecha</TableCell>
                <TableCell>Tipo</TableCell>
                <TableCell>Cajero / Módulo</TableCell>
                <TableCell>Categoría</TableCell>
                <TableCell>Estado</TableCell>
                <TableCell>Última actualización</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {s.solicitudes.length === 0 &&
                <TableRow><TableCell colSpan={7} align="center">Sin solicitudes</TableCell></TableRow>}
              {s.solicitudes.map(r => (
                <TableRow key={r.id} hover component={Link} to={'/dashboard/soporte/detalle?id=' + r.id} sx={{ textDecoration: 'none', cursor: 'pointer' }}>
                  <TableCell>{r.sup}{r.bandera_reabierta ? ' ↺' : ''}</TableCell>
                  <TableCell>{r.fecha_creacion}</TableCell>
                  <TableCell>{r.tipo === 'maquina' ? 'Máquina' : 'Plataforma'}</TableCell>
                  <TableCell>{r.tipo === 'maquina' ? (r.cajero_codigo || '-') : (r.modulo || '-')}</TableCell>
                  <TableCell>{r.categoria || '-'}</TableCell>
                  <TableCell><Chip size="small" label={r.estado} color={COLOR_ESTADO[r.estado] || 'default'} /></TableCell>
                  <TableCell>{r.fecha_actualizacion || r.fecha_creacion}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>}
        </Paper>
      </Box>
    )
  }
}

export default SoporteSeguimientosPage
